module.exports = "img/flags/CR.5fb2f06.png";